module.exports = __webpack_public_path__ + "media/images/mes_180_gmina-29f513d6314de82e29afd48fb5cedbbc.png";